import type { ReactNode } from "react";

import { Text, type TextProps } from "@/components/text/text.component";
import { Tooltip } from "@/components/tooltip/tooltip.component";

export const CompareRowLabel = ({
  label,
  tooltipLabel,
  info,
  component = "span",
  variant,
  className,
}: CompareRowLabelProps) => {
  const accessibleLabel =
    tooltipLabel ?? (typeof label === "string" ? label : "");

  return (
    <Text
      role="cell"
      variant={variant}
      component={component}
      className={
        className ??
        "inline align-middle lg:grid lg:grid-cols-[minmax(0,1fr)_auto] lg:items-center lg:gap-2"
      }>
      <span className="min-w-0 [&_p]:inline">{label}</span>
      {info ? (
        <Tooltip label={accessibleLabel} text={info} placement="compare-row" />
      ) : null}
    </Text>
  );
};

type CompareRowLabelProps = {
  label: ReactNode;
  tooltipLabel?: string;
  info?: string | null;
  component?: TextProps["component"];
  variant?: TextProps["variant"];
  className?: string;
};
